import { Component, QueryList, ContentChildren, Input } from '@angular/core';

@Component({
	selector: 'nm-tab',
	template: `
		<div class="tab-pane">
			<ng-content></ng-content>
		</div>
	`,
	host: {
		'[attr.id]': 'tabId',
		'[attr.class]': 'tabClass',
	}
})
export class NmTab {
	@Input() name: string;
	public tabId: string;
	public tabClass: string = 'tab-pane';
}

@Component({
	selector: 'nm-tabs',
	templateUrl: './tab.html'
})
export class NmTabs {
	@ContentChildren(NmTab) tabs: QueryList<NmTab>;
	@Input() class: string;

	public ngAfterContentInit() {
		setTimeout(() => {
			this.tabs.forEach((tab, i) => {
				tab.tabId = tab.name.toLowerCase().replace(/\s/g, '_');
				if(i == 0)
					tab.tabClass += ' active';
			});
		}, 100);
	}
}


// WEBPACK FOOTER //
// ./src/widgets/tab/tab.ts